import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { AvatarInput } from '../../../../common/inputs/AvatarInput';
import { FileInput } from '../../../../common/inputs/FileInput';
import { ColorInput } from '../../../../common/inputs/ColorInput';
import { IGeneralSettingsFormProps } from './types';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitButton } from '../../../../common/forms/SubmitButton';
import { updateSettings } from '../../../../../../app/page/settings/settings.actions';
import { IGeneralSettingsForm } from '../../../../../../app/page/settings/settings.types';
import { subscriptionAccessSelectors } from '../../../../../../app/resource/subscription-access/subscription-access.selectors';

export const GeneralSettingsForm: FunctionComponent<IGeneralSettingsFormProps> = ({ data }) => {
  const formProps = useForm();
  const dispatch = useDispatch();
  const aiNotesEnabled = useSelector(subscriptionAccessSelectors.selectAiNotesEnabled);

  const onSubmit = (formData: IGeneralSettingsForm) => {
    if (!aiNotesEnabled) {
      formData.enableMeetingsRecording = !!data?.enableMeetingsRecording;
    }
    dispatch(updateSettings(formData));
  };

  return (
    <div className="col px-0">
      <div className="field-container px-2 mb-5">
        <div className="panel theme-gradient-2 py-1 px-2 flex aic mb-3">
          <h2 className="f-14 white bold">GENERAL SETTINGS</h2>
        </div>
        <FormProvider {...formProps}>
          <form
            id="general-settings-form"
            className="topic-form"
            onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as IGeneralSettingsForm))}
            action=""
            method="post"
          >
            <div className="popup-upload-panel" style={{}}>
              <AvatarInput
                defaultValue={data?.iconLogo}
                id="iconLogo"
                name="iconLogo"
                label={`Upload tenant avatar`}
                maxImageSize={0.5}
                acceptableFormats={'jpg, png, gif, webp'}
                helpText="Recommended size: 50x50px"
              />
            </div>

            <div className="popup-upload-panel settings-dashboard-logo" style={{}}>
              <FileInput
                defaultValue={data?.dashboardLogo}
                id="dashboardLogo"
                name="dashboardLogo"
                label={`Upload dashboard logo`}
                maxFileSize={0.5}
                acceptableFormats={'jpg, png, gif, webp'}
                accept="image/*"
                showPreview={true}
                helpText="Recommended size: 190x100px"
              />
            </div>

            <div className="popup-upload-panel">
              <ColorInput
                id="primaryColor1"
                name="primaryColor1"
                placeholder="Theme color"
                defaultValue={data?.primaryColor1}
                resettableToDefaultColor
              />
            </div>

            {aiNotesEnabled && (
              <div className="popup-upload-panel row mb-1">
                <div className="col-12 pr-1">
                  <div className="flex aic ">
                    <label className="switch big-switch mr-1 mb-0" htmlFor="enableMeetingsRecording">
                      <input
                        type="checkbox"
                        className="switch-input change-theme"
                        id="enableMeetingsRecording"
                        name="enableMeetingsRecording"
                        defaultChecked={!!data?.enableMeetingsRecording}
                        ref={formProps.register}
                      />
                      <span className="switch-label"></span>
                      <span className="switch-handle"></span>
                    </label>
                    <span className="switch-inline-text">Enable meetings recording and transcription</span>
                  </div>
                </div>
              </div>
            )}

            <SubmitButton apiKey="saveSettings" formName="general-settings-form" text="Save" styles="btn my-2" />
          </form>
        </FormProvider>
      </div>
    </div>
  );
};
